import { useState } from "react";
import { pageClass, pageHeader } from "../../Components/Utils/CustomClasses";
import TreeChart from "./TreeChart";

export default function TeamHeirachy() {
  return (
    <div className={`${pageClass}`}>
      <div className="bg-[#FFFFFF] p-10 rounded-xl">
        <div className="flex items-center justify-between">
          <h1 className={`${pageHeader} text-xl md:text-2xl lg:text-3xl`}>
            Team Hierarchy
          </h1>
        </div>
        <div className="min-w-[361px] sm:min-w-[400px]">
          <div className="flex flex-col sm:flex-row">
            <div className="w-full">
              <div className="mt-4">
                <TreeChart />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
